export function formatPhoneNumber(phoneNumber?: string): string {
  if (!phoneNumber) {
    return '';
  }

  let cleanNumber = phoneNumber.replace(/(?!^\+)[^\d]/g, '');

  if (!cleanNumber.startsWith('+41')) {
    cleanNumber = '+41' + cleanNumber;
  }

  const formattedNumber = cleanNumber.replace(
    /^\+41(\d{2})(\d{3})(\d{2})(\d{2})$/,
    '+41 $1 $2 $3 $4',
  );

  return formattedNumber;
}
